import ApiService from './api.service'
import { TokenService } from './storage.service'

const CustomerSearchService = {
    getCustomerByKeyWord: async (keyword) => {
        let data = {
            keyword: keyword
        }
        // console.log(data)
        const requestData = {
            method: 'post',
            url: '/api/FacilitySearch/GetFacilitiesByKeyWord',
            data
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (error) {
            throw error
        }
    },

    getFacilityDataById: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/FacilitySearch/GetFacilityDataById',
            data: payload
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    }
}

export default CustomerSearchService